let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("zuZra")).then(() => parcelRequire('4HjU6'));